import { render, staticRenderFns } from "./fourthCard.vue?vue&type=template&id=61ba7ef9&scoped=true&"
import script from "./fourthCard.vue?vue&type=script&lang=js&"
export * from "./fourthCard.vue?vue&type=script&lang=js&"
import style0 from "./fourthCard.vue?vue&type=style&index=0&id=61ba7ef9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ba7ef9",
  null
  
)

export default component.exports